import Phaser from 'phaser';

// Bootstrap-подобная сетка: делит прямоугольник на cols × rows ячеек, возвращает
// pixel-координаты для (col, row[, span]). Заменяет ручные `x: 50 * uiScale` и
// аналоги. Для HUD используется sceneGrid (вся сцена); для field/dialog —
// gridFromBox от произвольного бокса. Сетка не хранит state — пересоздаётся на
// каждый resize через relayoutHUD().

export interface GridBox {
  left: number;
  top: number;
  width: number;
  height: number;
}

export interface GridCell {
  x: number;
  y: number;
  w: number;
  h: number;
  cx: number;
  cy: number;
  right: number;
  bottom: number;
}

export interface Grid {
  readonly cols: number;
  readonly rows: number;
  readonly box: GridBox;
  readonly cellW: number;
  readonly cellH: number;
  cell(col: number, row: number, span?: { c?: number; r?: number }): GridCell;
}

export const DEFAULT_GRID_COLS = 12;
export const DEFAULT_GRID_ROWS = 9;

export function gridFromBox(
  box: GridBox,
  cols = DEFAULT_GRID_COLS,
  rows = DEFAULT_GRID_ROWS,
): Grid {
  const cellW = box.width / cols;
  const cellH = box.height / rows;
  return {
    cols,
    rows,
    box,
    cellW,
    cellH,
    cell(col, row, span = {}) {
      const c = span.c ?? 1;
      const r = span.r ?? 1;
      const x = box.left + col * cellW;
      const y = box.top + row * cellH;
      const w = c * cellW;
      const h = r * cellH;
      return {
        x,
        y,
        w,
        h,
        cx: x + w / 2,
        cy: y + h / 2,
        right: x + w,
        bottom: y + h,
      };
    },
  };
}

// Сетка по всему окну (raw scene). HUD-элементы (магазин, HP, деньги, патроны,
// boss bar) ориентируются на края окна, поэтому это базовая сетка для HUD.
export function sceneGrid(
  scene: Phaser.Scene,
  cols = DEFAULT_GRID_COLS,
  rows = DEFAULT_GRID_ROWS,
): Grid {
  return gridFromBox(
    { left: 0, top: 0, width: scene.scale.width, height: scene.scale.height },
    cols,
    rows,
  );
}
